<template>
    <div class="box" :style="`background-image: url(${$OSSBaseUrl}buildphone_bg.png)`">
        <div class="content_box">
            <table>
                <tbody>
                    <tr>
                        <td>手机号</td>
                        <td>
                            <input v-model="phone" @input="phone_input" type="text" maxlength="11" placeholder="请输入手机号">
                        </td>
                        <td>
                            <div @click="get_code" class="get_code">{{get_code_text}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>验证码</td>
                        <td>
                            <input v-model="code" @input="code_input" type="text" maxlength="6" placeholder="请输入验证码">
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <div class="button_box">
                <div @click="submit" class="btn bgc_blue">
                    {{ !$route.query.title?'确定':'确定更换'}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import close_page from '@/utils/close_page';
import { Toast } from 'vant';
import { mapState } from 'vuex';
import verification from '@/utils/verification';
export default {
    name: 'BuildPhone',
    data(){
        return{
            timer: null,
            phone: '',
            code: '',
            BindStatus: true,
            BindMessage: '网络连接失败',
            get_code_text: '获取验证码',
            page_from: this.$route.query.page_from, //从哪个页进来的
            receiver_id: sessionStorage.getItem('Phone_Account_ID'),
        }
    },
    mounted(){
        if( !this.$route.query.title ){ // 获取绑定状态 , 从修改页面进来的不获取 , 绑定过且非修改不允许重复绑定
            this.$store.dispatch('BuildPhone/GetMobileBindStatus',{
                page_from: this.page_from,
                receiver_id: this.receiver_id,
            }).then((res)=>{
                this.BindStatus = res.code == 1000? true:false
                this.BindMessage = res.message
                if(res.code!=1000){ // 成功不提示
                    Toast(res.message)
                }
            })
        }
    },
    methods:{
        phone_input(){
            let res = verification.int(this.phone)
            if(!res.state){
                this.phone = this.phone.substring(0,res.index)
            }
        },
        code_input(){
            let res = verification.int(this.code)
            if(!res.state){
                this.code = this.code.substring(0,res.index)
            }
        },
        true_BindStatus(){
            if(this.BindStatus){
                return true
            }else{
                Toast(this.BindMessage)
                return false
            }
        },
        true_phone(){
            if(this.phone.length==11){
                return true
            }else{
                Toast('请输入正确手机号');
                return false
            }
        },
        true_code(){
            if(this.code.length==6){
                return true
            }else{
                Toast('请输入正确验证码');
                return false
            }
        },
        get_code(){
            if(  this.true_BindStatus() && this.true_phone() ){
                if(this.get_code_text=='获取验证码'){
                    this.$store.dispatch('BuildPhone/GetVerifyCode',{
                        mobile:this.phone,
                        page_from: this.page_from,
                        receiver_id: this.receiver_id,
                    }).then((res)=>{
                        let i = 60
                        if(res.code==1000){
                            Toast('验证码已发送至\n'+this.phone)
                            this.timer = setInterval(()=>{
                                if(i-- <=0 ){
                                    this.get_code_text = '获取验证码'
                                    clearInterval(this.timer)
                                }else{
                                    this.get_code_text = i+'秒'
                                }
                            },1000)
                        }else{
                            Toast(res.message)
                        }
                    })
                }else{
                    Toast('请勿频繁获取验证码')
                }
            }
        },
        submit(){
            if(  this.true_BindStatus() && this.true_phone() && this.true_code() ){
                this.$store.dispatch(
                    'BuildPhone/BindingMobile',
                    {
                        mobile:this.phone,
                        msg_code:this.code,
                        page_from: this.page_from,
                        receiver_id: this.receiver_id,
                    }
                ).then((res)=>{
                    if(res.code==1000){
                        Toast('手机号绑定成功')
                        setTimeout(()=>{
                            if( new URLSearchParams(window.location.search).get('is_link')==1 ){ // 从链接进来的关闭页面
                                close_page()
                                return false;
                            }
                            if(sessionStorage.getItem('BootBuildPhone')){//从消息接收设置页通过提示跳转来的
                                let params = {}
                                params[ sessionStorage.getItem('BootBuildPhone') ] = 0
                                sessionStorage.removeItem('BootBuildPhone')
                                // 绑定成功后 自动打开相应消息开关
                                this.$store.dispatch('MessageSwitch/SetRemindChannel', params).then(res=>{
                                    this.$router.push('MessageSwitch')
                                })
                            }else{ // 其他情况
                                this.$router.push('BuildAccount')
                            }
                        },2000)
                    }else{
                        Toast(res.message)
                    }
                })
            }
        }
    },
    beforeDestroy(){
        clearInterval(this.timer)
    }
}
</script>
<style lang="scss" scoped>
    @import './index.scss';
</style>